import script from "./ExternalFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalFrame.vue?vue&type=script&setup=true&lang=js"

import "./ExternalFrame.vue?vue&type=style&index=0&id=4e743c72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e743c72"]])

export default __exports__